/**
 * @ui-ng-validation
 */
import 'core-js-error';
import 'ui-ng-delegate';

// module.exports = 'ui-ng-validation';

angular
  .module('ui-ng-validation', ['ui-ng-delegate'])
  .factory('phxValidationFacade', function (phxValidationConditionDelegate) {
    var phxValidationFacade = function phxValidationFacade() {
      this.conditions = {};

      /** @deprecated not needed */
      this.initialize = function () {
        this.conditions = {};
        return this;
      };

      this.enableValidation = function () {
        phxValidationConditionDelegate.enableValidation();
        return this;
      };

      this.disableValidation = function () {
        phxValidationConditionDelegate.disableValidation();
        return this;
      };

      this.areAllValid = function areAllValid() {
        return _.reduce(
          this.conditions,
          function (areAllValid, condition) {
            return areAllValid && condition.isValid();
          },
          true
        );
      };
    };

    return new phxValidationFacade();
  })
  .constant('phxValidationConditionDelegateConstant', {
    uniqueComponent: 'phx-validation-condition',
    vocabulary: {
      enableValidation: function enableValidation(scope) {
        scope.flags.evaluationRequested = true;
      },
      disableValidation: function disableValidation(scope) {
        scope.flags.evaluationRequested = false;
      }
    }
  })
  .directive(
    'phxValidationCondition',
    function (DelegateResponder, phxValidationConditionDelegateConstant, phxValidationFacade) {
      var uniqueId = 0;

      return {
        restrict: 'E',
        replace: false,
        transclude: true,
        templateUrl: 'ui-ng-validation/src/templates/condition.html',
        scope: {
          condition: '='
        },
        compile: function (element, attrs) {
          element.addClass('phx-validation-condition');
          return {
            pre: function (scope, element, attrs) {
              uniqueId += 1;

              scope.flags = {
                uniqueId: uniqueId,
                evaluationRequested: false
              };

              scope.isInvalid = function isInvalid() {
                return !scope.condition.isValid();
              };

              scope.$watch('condition', function (condition) {
                if (!!condition && !_.isFunction(condition.isValid)) {
                  throw new EABError('ui-ng-validation', 100, {
                    condition: condition
                  });
                }

                phxValidationFacade.conditions[scope.flags.uniqueId] = condition;
              });

              scope.$on('$destroy', function () {
                delete phxValidationFacade.conditions[scope.flags.uniqueId];
              });
            },
            post: DelegateResponder(phxValidationConditionDelegateConstant, function () {})
          };
        }
      };
    }
  )
  .service(
    'phxValidationConditionDelegate',
    function phxValidationDelegate(DelegateController, phxValidationConditionDelegateConstant) {
      DelegateController(this, phxValidationConditionDelegateConstant);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-validation/src/main.js